<template>
    <div>
        <AccountBanner />
        <b-container>
            <b-row>
                <b-col md cols lg="4">
                    <UserBill />
                    <ServerList />
                    <UserSecurity />
                </b-col>
                <b-col md>
                    <DeviceList />
                    <UserCard />
                    <b-alert show variant="dark">
                        Need help with something? Go and read our
                        <b-link to="/faq">FAQs</b-link> or contact support.
                    </b-alert>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import AccountBanner from '@/components/auth/accountbanner.vue'
    import DeviceList from '@/components/user/devices/list.vue'
    import ServerList from '@/components/user/servers/list.vue'
    import UserCard from '@/components/user/user/card.vue'
    import UserBill from '@/components/user/user/bill.vue'
    import UserSecurity from '@/components/user/user/security.vue'

    export default {
        components: {
            AccountBanner,
            DeviceList,
            ServerList,
            UserCard,
            UserBill,
            UserSecurity
        }
    }
</script>

<style scoped>
</style>